import { Component, ViewChild, EventEmitter, Output, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Contact, ContactListCustomFields } from '../contact/contact.model';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { MessageDialogComponent } from '../../core/message-dialog/message-dialog.component';
import { MessageType } from '../../core/message-dialog/message-type.enum';
import { AntiForgeryTokenService } from '../../auth/anti-forgery-token.service';
import { SubSink } from 'subsink';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'contact-edit',
  templateUrl: './contact-edit.component.html',
  styleUrls: ['./contact-edit.component.css']
})

export class ContactEditComponent implements OnInit, OnDestroy {
  @ViewChild('editForm', { static: false }) editForm: NgForm;
  @ViewChild('msgDialog', { static: false }) msgDialog: MessageDialogComponent;

  private contact = new Contact();
  private isNew: boolean = true;
  private modal: any;
  private contactListCustomFields: ContactListCustomFields[] = [];
  private dtTable: any;
  private selectedCompany: number;
  private subs = new SubSink();

  @Output()
  private saved: EventEmitter<Contact> = new EventEmitter<Contact>();

  @Output()
  private unsubscribed: EventEmitter<Contact> = new EventEmitter<Contact>();

  constructor(private repository: HttpRepositoryService, private antiForgery: AntiForgeryTokenService) { }

  ngOnInit() {
    this.modal = $('#contactForm');
  }

  public show(contact: Contact, isNew: boolean, selectedCompany: number) {
    this.editForm.reset();
    this.contact = contact;
    this.isNew = isNew;
    this.selectedCompany = selectedCompany;

    if (contact.contactListCustomFields) {
      this.contactListCustomFields = contact.contactListCustomFields;

      this.contactListCustomFields.forEach(function (contactList) {
        contactList.customFieldJson.forEach(function (customField) {
          if (customField.type == 'logical' && customField.value == 'false') {
            customField.value = '';
          }
        });

      });
    }

    this.modal.modal({
      show: true,
      backdrop: 'static',
      keyboard: false,
    });
  }

  private save() {
    if (this.editForm.valid) {
      let id = (this.editForm.value.id == null) ? 0 : this.editForm.value.id;
      let email = this.contact.email ? '&' + this.contact.email : '&';
      let phone = this.contact.phone ? '&' + this.contact.phone : '&';
      let data = btoa(encodeURI(id + email + phone));

      if (this.isNew) {
        this.subs.sink = this.repository.get<Contact>('api/Contact/Unique?query=' + data + '&companyId=' + this.selectedCompany).subscribe(resp => {

          if (resp.data == null) {
            this.insert();
          } else {

            let msg = "Contact already exists!" + (resp.data.email ? " Email: " + resp.data.email + ", " : "")
              + (resp.data.phone ? " Phone: " + resp.data.phone + ", " : "")
              + ("Date added: " + resp.data.insAt + ". ")
              + "Click YES if you want to create contact, NO if you want to update or CANCEL if you want to quit";

            this.msgDialog.show(msg, MessageType.YESNOCANCEL, "Update conformation!", () => {
              this.insert();
            }, () => {
              this.contact.id = resp.data.id;
              this.update();
            })
          }
        });
      } else {
        this.update();
      }
    } else {
      Object.keys(this.editForm.controls)
        .forEach(fieldName => {
          this.editForm.controls[fieldName].markAsDirty();
        });
      $('#email').focus();
    }
  }

  private insert(): void {
    this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {
        Toast.Show(afResp.error, 'Create contact', 'error');
      } else {
        this.subs.sink = this.repository.post<Contact>('api/Contact/Create?companyId=' + this.selectedCompany, this.contact, afResp.data).subscribe(resp => {
          if (resp.hasErrors) {
            Toast.Show(resp.error, 'Create contact', 'error');
          } else {
            Toast.Show('Contact successfully created.', 'Create contact', 'success');
          }

          this.onSaveCompleted(resp.data);
        });
      }
    });
  }

  private update(): void {
    this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {
        Toast.Show(afResp.error, 'Update contact', 'error');
      } else {
        this.subs.sink = this.repository.put<Contact>('api/Contact/Edit?companyId=' + this.selectedCompany, this.contact, afResp.data).subscribe(resp => {
          if (resp.hasErrors) {
            Toast.Show(resp.error, 'Update contact', 'error');
          } else {
            Toast.Show('Contact successfully updated.', 'Update contact', 'success');
          }

          this.onSaveCompleted(resp.data);
        });
      }
    });
  }

  private unsubscribe(contactListName, idContactContactList) {
    this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {
        Toast.Show(afResp.error, 'Unsubscribe contact', 'error');
      } else {
        this.msgDialog.show('Are you sure you want to unsubscribe from ' + contactListName + '?', MessageType.YESNO, 'Unsubscribe conformation!', () => {
          this.subs.sink = this.repository.del('api/Contact/Unassign/' + idContactContactList, afResp.data).subscribe(resp => {
            if (resp.hasErrors) {
              Toast.Show(resp.error, 'Unsubscribe contact', 'error');
            } else {
              Toast.Show('Contact successfully unsubscribed.', 'Unsubscribe contact', 'success');
            }

            this.contact.contactListCustomFields.find(x => x.idContactContactList == idContactContactList).isUnsubscribed = true;
            $('#checkbox-' + idContactContactList).prop('checked', false);

            this.onUnsubscribeCompleted(this.contact);

          });
        });
      }
    });
  }

  private listUnsubscribe() {
    let checked: number[] = [];
    let that = this;

    $('.checkbox:checked').each(function () {
      checked.push(parseInt($(this)[0].id.substring(9)));
    });

    if (checked.length == 0) {
      this.msgDialog.show("You must select contact list!", MessageType.OK, "Unsubscribe conformation!");
    } else {
      this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
        if (afResp.hasErrors) {
          Toast.Show(afResp.error, 'Unsubscribe contact(s)', 'error');
        } else {
          this.msgDialog.show('Are you sure you want to unsubscribe this ' + checked.length + ' item(s)?', MessageType.YESNO, 'Unsubscribe conformation!', () => {
            this.subs.sink = this.repository.post<number[]>('api/Contact/ListUnassign', checked, afResp.data).subscribe(resp => {
              if (resp.hasErrors) {
                Toast.Show(resp.error, 'Unsubscribe contact(s)', 'error');
              } else {
                Toast.Show('Contact(s) successfully unsubscribed.', 'Unsubscribe contact(s)', 'success');
              }

              checked.forEach(function (item) {
                that.contact.contactListCustomFields.find(x => x.idContactContactList == item).isUnsubscribed = true;
                $('#checkbox-' + item).prop('checked', false);
              });

              this.onUnsubscribeCompleted(resp);
            });
          });
        }
      });
    }
  }

  private exclusiveUnsubscribe(id: number, contactName: string) {
    this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {

      } else {
        this.msgDialog.show("Are you shure you want to unsubscribe " + contactName + " from all subscribed contact lists?", MessageType.YESNO, "Unsubscribe conformation!", () => {
          this.subs.sink = this.repository.del('api/Contact/ExclusiveUnassign/' + id, afResp.data).subscribe(resp => {
            if (resp.hasErrors) {
              Toast.Show(resp.error, 'Unsubscribe contact', 'error');
            } else {
              Toast.Show('Contact successfully unsubscribed.', 'Unsubscribe contact(s)', 'success');
              this.onUnsubscribeCompleted(id);
            }
          });

          this.close();
        });
      }
    });
  }

  private onSaveCompleted(data: Contact) {
    this.close();
    this.saved.emit(data);
  }

  private onUnsubscribeCompleted(data: any) {
    this.unsubscribed.emit(data);
  }

  selectAll() {
    $("#checkSelectAll").change(function () {
      var status = this.checked;
      $('.checkbox').each(function () {
        this.checked = status;

        if ($(this)[0].disabled == true) {
          this.checked = false;
        }
      });
    });

    $('.checkbox').change(function () {
      if (this.checked == false) {
        $("#checkSelectAll")[0].checked = false;
      }

      if ($('.checkbox:checked').length == $('.checkbox').length) {
        $("#checkSelectAll")[0].checked = true;
      }
    });
  }

  close() {
    this.modal.modal('hide');
    this.contact = new Contact();

    $('input:checkbox').each(function () {
      this.checked = false;
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
